import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-navy" data-id="element-101" data-mp="1o3dmwcdeadr5">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-102" data-mp="2223jlqwaybez">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-gold text-gold" data-id="element-103" data-mp="1x3tpzkq87ivh">
          <span className="font-display text-4xl leading-none" data-id="element-104" data-mp="19fadsu422ly4">7</span>
          <span className="font-display text-xs uppercase tracking-widest" data-id="element-105" data-mp="14gfn75zujt3g">Days</span>
        </div>
        <p className="mt-6 text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-106" data-mp="1j4txg1zleju1">Zero risk</p>
        <h2 id="guarantee-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-107" data-mp="1edk8l3lvbkj7">
          Open Week 1. Teach it.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-white/75" data-id="element-108" data-mp="lpy8i5bumy13">
          Print Monday, Wednesday and Friday, run your classes straight off the
          page, try the swaps and the scripts. If The Decided Bootcamp doesn&apos;t
          give you your Sunday night back, email us inside 7 days and you get
          every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-109" data-mp="yrfmuwr0axbb">
          {chips.map(chip => <li key={chip} className="rounded-full border border-navy-line px-4 py-2 text-[13px] text-white/75" data-id="element-110" data-mp="12t0ykert15jx">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}